import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorService {
    private error?: HttpErrorResponse;

    addError(errorResponse: HttpErrorResponse) {
        this.error = errorResponse;
    }

    getError() {
        return this.error;
    }
}
